import { SearchTerm } from "./SearchTerm";

const InstallPeripheralsSearch: SearchTerm[] = [
    {
        heading: "Fixed Address",
        accessor: "fixedAddress",
        searchOnName: "fixedAddress",
        translationKey: "fixedAddress"
    }
]

export default InstallPeripheralsSearch;
